import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../Contact/Contact.css";
import "./AdBusinessDetails.css";
import Select from 'react-select';
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import { PhoneInput } from "react-international-phone";
import {
  addBusinessDetails,
  getBusinessData,
  getBusinessCategories,
  getBusinessTypes,
} from "../../API/ApiService";
import { loadingAction } from "../../Redux/Action/loadingAction";
import DefaultImage from "../../assets/images/add-image.png";
import { AiFillTikTok } from "react-icons/ai";
import { addBusinessImage } from "../../API/ApiService";
import { usePlacesWidget } from "react-google-autocomplete";
import { BUSINESS_TYPE_SIGN_IN, FACEBOOK_REGEX, GOOGLE_API_KEY, INSTAGRAM_REGEX, LINKEDIN_REGEX, TICKTOCK_REGEX, TWITTER_REGEX, WEBSITE_REGEX, YOUTUBE_REGEX } from "../../Utils/constants";
import { addBusinessDetail } from "../../Redux/Action/BusinessAction/businesAction";
import { getItemLocalStorage } from "../../Utils/localStroge";
import { isPhoneValid } from "../../Utils/helperFunction";

// import MobileLeft from "../../assets/images/mobile2.png";
// import MobileRight from "../../assets/images/mobile.png";
const dot = (color = 'transparent') => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: 8,
    height: 10,
    width: 10,
  },
});
const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'black', border: '1px solid rgba(102, 102, 102, 0.35) !important', borderRadius: '12px', height: '50px' }),
  input: (styles) => ({ ...styles, border: 'none !important' }),
  placeholder: (styles) => ({ ...styles, paddingLeft: 3 }),
  singleValue: (styles, { data }) => ({ ...styles, color: '#fff', paddingLeft: 5 }),
};

const AdBusinessDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation()
  const navigate = useNavigate();
  const { userBusinessDetails } = useSelector((state) => state.businessData);
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [currentCountry, setCurrentCountry] = useState(null); // Add this for validation
  const [tags, setTags] = React.useState([]);
  const [categories, setCategories] = useState();
  const [businessTypes, setBusinessTypes] = useState();
  const [isAddressHide, setAddressHide] = useState(false);
  const [avatarURL, setAvatarURL] = useState(DefaultImage);
  const [uploadedFile, setUploadedFile] = useState();
  const [countryIsoCode, setCountryIsoCode] = useState("");

  const fileUploadRef = useRef();

  const checkedVal = getItemLocalStorage("sign_in_type");

  useEffect(() => {
    if (checkedVal === BUSINESS_TYPE_SIGN_IN) {
      if (userBusinessDetails && userBusinessDetails.id && userBusinessDetails.business_name) {
        navigate(
          `/businessDetails/${userBusinessDetails.id}?name=${userBusinessDetails.business_name
            ?.trim()
            ?.replaceAll(" ", "_")}`,
          { state: { businessId: userBusinessDetails.id } }
        );
      }
    } else {
      navigate('/')
    }
  }, [userBusinessDetails, checkedVal])

  const handleImageUpload = (event) => {
    event.preventDefault();
    fileUploadRef.current.click();
  };

  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result.split(',')[1]); // Extract base64 data
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  const uploadImageDisplay = async () => {
    try {
      const file = fileUploadRef.current.files[0]
      const convertedImage = await convertImageToBase64(file)
      // console.log(convertedImage, file, "//????");
      setUploadedFile({
        image: convertedImage,
        format: file?.type?.split("/")[1]
      });

      const cachedURL = URL.createObjectURL(fileUploadRef.current.files[0]);
      setAvatarURL(cachedURL);
    } catch (error) {
      console.error(error);
      // setAvatarURL(DefaultImage);
      toast.error(error?.response?.data?.message);
    }
  };

  // Custom phone validation function
  const validatePhone = (value) => {
    if (!value) return false;
    
    // Check if current country is Jamaica
    if (currentCountry?.iso2?.toLowerCase() === 'jm') {
      const cleanPhone = value.replace(/\D/g, '');
      
      
      if (cleanPhone.length === 11 && cleanPhone.startsWith('1876')) return true;
      if (cleanPhone.length === 10 && (cleanPhone.startsWith('1876') || cleanPhone.startsWith('876'))) return true;
      if (cleanPhone.length === 7) return true;
      
      return false;
    }
    
    // For other countries, use existing validation
    return isPhoneValid(value);
  };

  const formik = useFormik({
    initialValues: {
      business_name: "",
      email: "",
      tag_line: "",
      tag: [],
      message: "",
      description: "",
      phone: "",
      busi_cat_id: "",
      busi_type_id: "",
      website: "",
      address: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      zipcode: "",
      lat: "",
      lng: "",
      status: 1,
      facebook: "",
      twitter: "",
      linkedIn: "",
      instagram: "",
      tiktok: "",
      youtube: "",
      is_address_hide: 1,
      is_claimed: 1,
      country_code: "",
      additionalWebsite: ""
    },
    validationSchema: Yup.object({
      business_name: Yup.string().trim().required("Name Required"),
      email: Yup.string()
        .trim()
        .email("Invalid email"),
      description: Yup.string().trim().required("Description Required"),
      phone: Yup.string()
        .trim()
        .required("Phone Required")
        .test(
          'isValidPhoneNumber',
          'Please input a valid phone number',
          validatePhone
        ),
      busi_cat_id: Yup.string().trim().required("Business Category Required"),
      busi_type_id: Yup.string().trim().required("Business Type Required"),
      facebook: Yup.string().trim().matches(FACEBOOK_REGEX, { message: 'Please enter a valid facebook url', excludeEmptyString: true }),
      instagram: Yup.string().trim().matches(INSTAGRAM_REGEX, { message: 'Please enter a valid instagram url', excludeEmptyString: true }),
      linkedIn: Yup.string().trim().matches(LINKEDIN_REGEX, { message: 'Please enter a valid linkedIn url', excludeEmptyString: true }),
      twitter: Yup.string().trim().matches(TWITTER_REGEX, { message: 'Please enter a valid twitter url', excludeEmptyString: true }),
      youtube: Yup.string().trim().matches(YOUTUBE_REGEX, { message: 'Please enter a valid youtube url', excludeEmptyString: true }),
      tiktok: Yup.string().trim().matches(TICKTOCK_REGEX, { message: 'Please enter a valid tiktok url', excludeEmptyString: true }),
      website: Yup.string().trim().matches(WEBSITE_REGEX, { message: 'Please enter a valid url', excludeEmptyString: true }),
      additionalWebsite: Yup.string().trim().matches(WEBSITE_REGEX, { message: 'Please enter a valid url', excludeEmptyString: true }),
      address1: Yup.string().trim().required("Address Line 1 Required"),
      // address1: Yup.string().trim().required("Address Line 2 Required"),
      // country: Yup.string().trim().required("Country Required"),
      // state: Yup.string().trim().required("State Required"),
      // city: Yup.string().trim().required("City Required"),
      zipcode: Yup.string().trim().required("Zip code Required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      let finalCountryCode = countryCode;
      let finalPhone;

      if (currentCountry?.iso2?.toLowerCase() === 'jm') {
        // For Jamaica: send country code as +1876 and only 7 digit local number
        finalCountryCode = "+1876";
        // Extract only 7 digit local number from the full phone
        let jamaicaLocal = phone.replace(/\D/g, '');
        if (jamaicaLocal.startsWith('1876')) {
          jamaicaLocal = jamaicaLocal.substring(4); // Remove "1876"
        } else if (jamaicaLocal.startsWith('876')) {
          jamaicaLocal = jamaicaLocal.substring(3); // Remove "876"
        }
        finalPhone = jamaicaLocal; // Send only 7 digits
      } else {
        // For other countries: send only local number without country code
        finalPhone = phoneNumber; // This already has local number without country code
      }

      let body = JSON.stringify({
        business_name: values.business_name,
        description: values?.description,
        tag_line: values.tag_line,
        tag: tags || [],
        country_code: finalCountryCode,
        phone: finalPhone, 
        busi_cat_id: values?.busi_cat_id,
        busi_type_id: values?.busi_type_id,
        business_email: values.email,
        website: values?.website,
        alternative_website: values?.additionalWebsite,
        address1: values?.address1,
        address2: values?.address2,
        address: values?.address,
        city: values?.city,
        state: values?.state,
        country: values?.country,
        country_iso_code: countryIsoCode,
        zipcode: values?.zipcode,
        lat: values?.lat,
        lng: values?.lng,
        status: 1,
        facebook: values?.facebook,
        twitter: values?.twitter,
        linkedIn: values?.linkedIn,
        instagram: values?.instagram,
        tiktok: values?.tiktok,
        youtube: values?.youtube,
        is_address_hide: isAddressHide ? 2 : 1,
        is_claimed: 1,
      });
      dispatch(loadingAction(true));

      // console.log(body, "//");

      try {
        let response = await addBusinessDetails(body);
        if (response) {
          dispatch(loadingAction(false));
          toast.success("Business Added Successfully");
          if (uploadedFile && uploadedFile?.image && uploadedFile?.format) {
            const body = uploadedFile
            const response = await addBusinessImage(body);
            getBusinessData().then((res) => {
              localStorage.setItem("id", res?.data?.result?.id);
              localStorage.setItem("businessName", res?.data?.result?.business_name);
              dispatch(addBusinessDetail(res?.data?.result))
            });
            if (response) {
              navigate(location?.state?.backRoute || "/");
            }
          } else {
            getBusinessData().then((res) => {
              localStorage.setItem("id", res?.data?.result?.id);
              localStorage.setItem("businessName", res?.data?.result?.business_name);
              dispatch(addBusinessDetail(res?.data?.result))
            });
            navigate(location?.state?.backRoute || "/");
          }
          navigate(location?.state?.backRoute || "/");
          resetForm();
        } else {
          dispatch(loadingAction(false));
          toast.error("Somethings went wrong!");
        }
      } catch (err) {
        dispatch(loadingAction(false));
        // console.log(err);
      }
    },
  });

  const { ref, autocompleteRef } = usePlacesWidget({
    apiKey: GOOGLE_API_KEY,
    options: {
      types: ["address"]
    },

    onPlaceSelected: (details) => {
      // console.log(details, "/////");
      const address_components =
        details?.address_components || [];
      const streetNumber = address_components.filter(
        (ele) => ele.types.indexOf("street_number") !== -1
      );
      const streetAddress = address_components.filter(
        (ele) => ele.types.indexOf("route") !== -1
      );
      const state = address_components.filter(
        (ele) =>
          ele.types.indexOf("administrative_area_level_1") !==
          -1
      );
      const city = address_components.filter(
        (ele) => ele.types.indexOf("locality") !== -1
      );
      const zipCode = address_components.filter(
        (ele) => ele.types.indexOf("postal_code") !== -1
      );
      const area = address_components.filter(
        (ele) => ele.types.indexOf("neighborhood") !== -1
      );
      const country = address_components.filter(
        (ele) => ele.types.indexOf("country") !== -1
      );
      const city1 = address_components.filter(
        (ele) => ele.types.indexOf("postal_town") !== -1
      );
      let address = {
        addressLine1: details?.formatted_address
          ?.split(",")
          .slice(0, -2)
          .join(","),
        city:
          city && city?.length
            ? city[0]?.long_name
            : city1 && city1?.length
              ? city1[0]?.long_name
              : "",
        state:
          state && state?.length ? state[0]?.long_name : "",
        area: area && area?.length ? area[0]?.long_name : "",
        postCode:
          zipCode && zipCode?.length
            ? zipCode[0]?.long_name
            : "",
        lat:
          details?.geometry?.location &&
            details?.geometry?.location?.lat
            ? details?.geometry?.location?.lat
            : null,
        lng:
          details?.geometry?.location &&
            details?.geometry.location?.lng
            ? details?.geometry?.location?.lng
            : null,
        country:
          country && country?.length
            ? country[0]?.long_name
            : "",
        countryIso: country && country?.length ? country[0]?.short_name : "",
      };
      // formik.values.city = address?.city;
      formik.setFieldValue('address', address?.addressLine1)
      formik.setFieldValue('address1', address?.addressLine1)
      formik.setFieldValue('lat', address?.lat())
      formik.setFieldValue('lng', address?.lng())
      formik.setFieldValue('zipcode', address?.postCode)
      formik.setFieldValue('city', address?.city)
      formik.setFieldValue('state', address?.state)
      formik.setFieldValue('country', address?.country)
      // formik.values.lat = address?.lat;
      // formik.values.lng = address?.lng;
      // formik.values.zipcode = address?.postCode;
      // console.log(address, "???????");
      setCountryIsoCode(address?.countryIso);
    }
   
  }, [formik]);

  const handlePhone = (phone, country, inputvalue) => {
    setPhone(phone);
    setCurrentCountry(country); 
    
    if (country?.iso2?.toLowerCase() === 'jm') {
      setCountryCode("+1876");
      
      // Extract the 7-digit local number (remove +1876 prefix)
      let jamaicaNumber = phone.replace("+", "");
      if (jamaicaNumber.startsWith("1876")) {
        jamaicaNumber = jamaicaNumber.substring(4); // Remove "1876"
      } else if (jamaicaNumber.startsWith("876")) {
        jamaicaNumber = jamaicaNumber.substring(3); // Remove "876"
      }
      setPhoneNumber(jamaicaNumber);
    } else {
      // For other countries, use existing logic
      setCountryCode("+" + country?.dialCode);
      let mystring = phone.replace("+", "");
      mystring = mystring.replace(country?.dialCode, "");
      setPhoneNumber(mystring);
    }
  };

  const addTags = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      setTags([...tags, event.target.value]);
      event.target.value = "";
    }
  };

  const removeTags = (index) => {
    setTags([...tags.filter((tag) => tags.indexOf(tag) !== index)]);
  };

  useEffect(() => {
    if (formik) {
      formik.values.tag = tags;
    }
  }, [tags, formik]);

  useEffect(() => {
    if (formik) {
      formik.values.phone = phone;
    }
  }, [phone, formik]);

  // get categories
  const getCategories = async () => {
    const response = await getBusinessCategories();
    setCategories(response.data?.result);
  };

  //  get Business types
  const getTypes = async () => {
    const response = await getBusinessTypes();
    setBusinessTypes(response.data?.result);
  };

  useEffect(() => {
    if (!categories) {
      getCategories();
    }
    if (!businessTypes) {
      getTypes();
    }
  }, [categories, businessTypes]);

  return (
    <div style={{ marginBottom: 100 }}>
      <section className='heading'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <h2>Add Business Details</h2>
            </div>
            <div className='relative h-96 w-96 m-8'>
              <form id='form' encType='multipart/form-data'>
                <button
                  type='submit'
                  onClick={handleImageUpload}
                  className='flex-center absolute bottom-12 right-14 h-9 w-9 rounded-full'
                  style={{
                    border: "1px dashed  #3CA059",
                    borderRadius: "50%",
                    padding: "38px",
                    overflowClipMargin: "padding-box",
                    margin: "30px 0",
                    background: "transparent",
                  }}
                >
                  <img
                    src={avatarURL}
                    // src={https://bgz-business-dev.s3.us-east-2.amazonaws.com/d273b7eb-d82b-4c0b-a097-5d0101a033b4fbDA2A}
                    alt='Avatar'
                    height={70}
                    width={70}
                    style={
                      {
                        // borderRadius: "50%",
                      }
                    }
                  />
                </button>
                <input
                  type='file'
                  id='file'
                  accept='image/*'
                  ref={fileUploadRef}
                  onChange={uploadImageDisplay}
                  hidden
                />
              </form>
            </div>
          </div>
        </div>
      </section>
      <section className='contact-form pt-1'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <form onSubmit={e => { e.preventDefault(); }} onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                }
              }}>
                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <label className='input_label'>Business Name*</label>
                    <input
                      type='text'
                      name='business_name'
                      placeholder='Enter Business Name'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.business_name}
                    />
                    {formik.touched.business_name &&
                      formik.errors.business_name ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.business_name}
                      </div>
                    ) : null}
                  </div>
                  <div className='col-md-6'>
                    <label className='input_label'>Tagline</label>
                    <input
                      type='text'
                      name='tag_line'
                      placeholder='Enter Business Tagline'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.tag_line}
                    />
                    {formik.touched.tagline && formik.errors.tag_line ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.tag_line}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row my-2'>
                  <div className='col-md-12 my-2'>
                    <label className='input_label'>Business Description*</label>
                    <textarea
                      placeholder='Enter Business Description'
                      name='description'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.description}
                    />
                    {formik.touched.description && formik.errors.description ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row my-2'>
                  <div className='col-md-6'>
                    <label className='input_label'>
                      Business Contact Number*
                    </label>
                    <PhoneInput
                      defaultCountry='us'
                      value={phone}
                      onChange={(phone, { country, inputValue }) => {
                        handlePhone(phone, country, inputValue);
                      }}
                      onBlur={formik.handleBlur}
                      name='phone'
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.phone}
                      </div>
                    ) : null}
                  </div>
                  <div className='col-md-6'>
                    <label className='input_label'>Business Category*</label>
                    <Select
                      styles={colourStyles}
                      classNamePrefix="select"
                      isSearchable
                      name="color"
                      id="busi_cat_id"
                      onChange={(value) => {
                        // console.log(value, "???");
                        formik.setFieldValue('busi_cat_id', value.value)

                      }}
                      options={categories?.map((cat) => ({
                        label: cat.category_name,
                        value: cat.id
                      })) || []}
                    />
                    {formik.touched.busi_cat_id && formik.errors.busi_cat_id ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.busi_cat_id}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row my-2'>
                  <div className='col-md-6'>
                    <label className='input_label'>Business Type*</label>
                    <select
                      className='form-select'
                      name='busi_type_id'
                      style={{ border: ' 1px solid rgba(102, 102, 102, 0.35)', height: '50px' }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.busi_type_id}
                    >
                      <option>Select Business Type</option>
                      {businessTypes &&
                        businessTypes?.map((cat) => (
                          <option key={cat.id} value={cat?.id}>{cat.business_type}</option>
                        ))}
                    </select>
                    {formik.touched.busi_type_id &&
                      formik.errors.busi_type_id ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.busi_type_id}
                      </div>
                    ) : null}
                  </div>
                  <div className='col-md-6'>
                    <label className='input_label'>Business Email</label>
                    <input
                      type='email'
                      name='email'
                      placeholder='Enter Business Email'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.email}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <label className='input_label'>Business Website</label>
                    <input
                      type='text'
                      name='website'
                      placeholder='Enter Business Website'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.website}
                    />
                    {formik.touched.website && formik.errors.website ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.website}
                      </div>
                    ) : null}
                  </div>
                  <div className='col-md-6'>
                    <label className='input_label'>Additional Website</label>
                    <input
                      type='text'
                      name='additionalWebsite'
                      placeholder='Enter Additional Website'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.additionalWebsite}
                    />
                    {formik.touched.additionalWebsite &&
                      formik.errors.additionalWebsite ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.additionalWebsite}
                      </div>
                    ) : null}
                  </div>
                </div>

                <hr className='text-white my-5' />
                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <label className='input_label'>
                      Business Address Line 1*
                    </label>
                    <input
                      type='text'
                      name='address1'
                      placeholder='Enter Business Address'
                      ref={ref}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address1}
                    />
                    {formik.touched.address1 && formik.errors.address1 ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.address1}
                      </div>
                    ) : null}
                  </div>
                  <div className='col-md-6'>
                    <label className='input_label'>
                      Business Address Line 2
                    </label>
                    <input
                      type='text'
                      name='address2'
                      placeholder='Enter Business Address'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address2}
                    />
                    {formik.touched.address2 && formik.errors.address2 ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.address2}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row my-2'>
                  <div className='col-md-6'>
                    <label className='input_label'>City</label>
                    <input
                      type='text'
                      name='city'
                      placeholder='City'
                      disabled
                      value={formik.values.city}
                    />
                    {formik.touched.city && formik.errors.city ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.city}
                      </div>
                    ) : null}
                  </div>
                  <div className='col-md-6'>
                    <label className='input_label'>State</label>
                    {/* <select
                    className='form-select'
                    name='state'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.state}
                  >
                    <option disabled defaultValue>
                      Select State
                    </option>
                  </select> */}
                    <input
                      type='text'
                      name='state'
                      placeholder='State'
                      disabled
                      value={formik.values.state}
                    />
                    {formik.touched.state && formik.errors.state ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.state}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row my-2'>
                  <div className='col-md-6'>
                    <label className='input_label'>Country</label>
                    <input
                      type='text'
                      name='country'
                      placeholder='Country'
                      disabled
                      value={formik.values.country}
                    />
                    {formik.touched.country && formik.errors.country ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.country}
                      </div>
                    ) : null}
                  </div>
                  <div className='col-md-6'>
                    <label className='input_label'>Zip Code*</label>
                    <input
                      type='text'
                      name='zipcode'
                      placeholder='Zip Code'
                      // disabled
                       onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.zipcode}
                    />
                    {formik.touched.zipcode && formik.errors.zipcode ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.zipcode}
                      </div>
                    ) :     <div style={{ color: "#666666", fontSize: "12px" ,marginTop:"4px" }}>
                      Note: If your country does not use zip codes, please enter
                      "Zipcode" as a placeholder to proceed.
                    </div>}
                    
                  </div>
                </div>
                <div className='row my-2'>
                  <div className='col-md-12 my-2'>
                    <label className='input_label'>Tags</label>
                    {/* <textarea
                      placeholder='Enter Your Business Tags'
                      name='tag'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.tag}
                    /> */}
                  </div>
                  <div className='tags-input'>
                    {tags.length > 0 && <ul style={{ paddingLeft: 0 }}>
                      {tags.map((tag, index) => (
                        <li key={index} >
                          <span>{tag}</span>
                          <i
                            className='material-icons'
                            onClick={() => removeTags(index)}
                          >
                            x
                          </i>
                        </li>
                      ))}
                    </ul>}
                    <input
                      type='text'
                      placeholder='Press enter to add tags'
                      onKeyUp={(event) => addTags(event)}
                    />
                    {formik.touched.tags && formik.errors.tag ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.tag}
                      </div>
                    ) : null}
                  </div>
                </div>
                <hr className='text-white my-5' />
                <h2 className="input_label mb-3">Social Connects</h2>
                <div className='row mb-4'>
                  <div className='col-md-6'>
                    {/* <label className='input_label'>
                      Facebook
                    </label> */}
                    <div style={{ position: "relative" }}>
                      <div className="social-icon-wrap" >
                        <img style={{ width: "32px" }} src="/images/fb-icon.svg" />
                        <span className="social-icon-http">https://</span>
                      </div>
                      <input
                        type='text'
                        name='facebook'
                        placeholder='Enter your facebook url'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.facebook}
                        className="input-padding"
                      />
                    </div>

                    {formik.touched.facebook && formik.errors.facebook ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.facebook}
                      </div>
                    ) : null}
                  </div>

                  <div className='col-md-6'>
                    {/* <label className='input_label'>
                      Instagram
                    </label> */}
                    <div style={{ position: "relative" }}>
                      <div className="social-icon-wrap" >
                        <img style={{ width: "32px" }} src="/images/insta-icon.svg" />
                        <span className="social-icon-http">https://</span>
                      </div>

                      <input
                        type='text'
                        name='instagram'
                        placeholder='Enter your Instagram url'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.instagram}
                        className="input-padding"
                      />
                    </div>
                    {formik.touched.instagram && formik.errors.instagram ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.instagram}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row mb-4'>
                  <div className='col-md-6'>
                    {/* <label className='input_label'>
                      Twitter
                    </label> */}
                    <div style={{ position: "relative" }}>
                      <div className="social-icon-wrap" >
                        <img style={{ width: "32px" }} src="/images/x-icon.svg" />
                        <span className="social-icon-http">https://</span>
                      </div>

                      <input
                        type='text'
                        name='twitter'
                        placeholder='Enter your twitter url'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.twitter}
                        className="input-padding"
                      />
                    </div>
                    {formik.touched.twitter && formik.errors.twitter ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.twitter}
                      </div>
                    ) : null}
                  </div>

                  <div className='col-md-6'>
                    {/* <label className='input_label'>
                      LinkedIn
                    </label> */}
                    <div style={{ position: "relative" }}>
                      <div className="social-icon-wrap" >
                        <img style={{ width: "32px" }} src="/images/lind-icon.svg" />
                        <span className="social-icon-http">https://</span>
                      </div>

                      <input
                        type='text'
                        name='linkedIn'
                        placeholder='Enter your linkedIn url'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.linkedIn}
                        className="input-padding"
                      />
                    </div>
                    {formik.touched.linkedIn && formik.errors.linkedIn ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.linkedIn}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row mb-4'>
                  <div className='col-md-6'>
                    {/* <label className='input_label'>
                      Tiktok
                    </label> */}
                    <div style={{ position: "relative" }}>
                      <div className="social-icon-wrap" >
                        {/* <img style={{width:"32px"}} src="/images/tiktok.svg" /> */}
                        <AiFillTikTok color="white" fontSize={"32px"} />
                        <span className="social-icon-http">https://</span>
                      </div>

                      <input
                        type='text'
                        name='tiktok'
                        placeholder='Enter your tiktok url'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.tiktok}
                        className="input-padding"
                      />
                    </div>
                    {formik.touched.tiktok && formik.errors.tiktok ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.tiktok}
                      </div>
                    ) : null}
                  </div>

                  <div className='col-md-6'>
                    {/* <label className='input_label'>
                      Youtube
                    </label> */}
                    <div style={{ position: "relative" }}>
                      <div className="social-icon-wrap" >
                        <img style={{ width: "32px" }} src="/images/yt-icon.svg" />
                        <span className="social-icon-http">https://</span>
                      </div>

                      <input
                        type='text'
                        name='youtube'
                        placeholder='Enter your youtube url'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.youtube}
                        className="input-padding"
                      />
                    </div>
                    {formik.touched.youtube && formik.errors.youtube ? (
                      <div
                        className='invalid-feedback'
                        style={{ display: "inline-block" }}
                      >
                        {formik.errors.youtube}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='row my-5'>
                  <div className='col-12 hide_business_details d-flex px-0'>
                    <input
                      type='checkbox'
                      id='is_address_hide'
                      name='is_address_hide'
                      value='is_address_hide'
                      onClick={() => setAddressHide(!isAddressHide)}
                    />
                    <label htmlFor='hideBusinessDetails'>
                      {" "}
                      Hide Business Details
                    </label>
                    <br />
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <button
                    className='submit_button btn btn-success'
                    style={{ width: 300, fontSize: '16px' }}
                    onClick={() => {
                      formik.handleSubmit()
                    }}
                  >
                    {" "}
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdBusinessDetails;